import { useState } from 'react';

import {
  Box, Dialog, DialogContent,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
  Stack,
  DialogTitle
} from '@mui/material';

import { Close, KeyboardArrowDownOutlined } from '@mui/icons-material';

import PatientAutocomplete from '../../Common/components/Patients/PatientAutocomplete';
import {
  menuProps,
  textFieldSx,
  multitextFieldSx,
  dialogHeaderStyles
} from '../../Common/components/Styles/InputStyles';
import CommonDialogActions from '../../Common/components/CommonDialogActions';


import { sectionTitleSx } from '../styles';

const patients = [
  {
    name: 'James Hunt',
    mr: '21040897',
    dob: '03/06/2006 (20 yrs)',
    sex: 'Male'
  },
  {
    name: 'Philip Cammee John',
    mr: '22351612',
    dob: '05/12/1985 (40 yrs)',
    sex: 'Male'
  },
  {
    name: 'Jennifer Lee',
    mr: '2318634',
    dob: '08/18/1992 (33 yrs)',
    sex: 'Female'
  },
  {
    name: 'Olivia Martin',
    mr: '21678902',
    dob: '11/25/1988 (37 yrs)',
    sex: 'Female'
  },
  {
    name: 'Robert Wilson',
    mr: '21985642',
    dob: '02/14/1975 (51 yrs)',
    sex: 'Male'
  }
];

const initialForm = {
  patient: null,
  category: '',
  issueNote: '',
  priority: '',
  routeTo: ''
};

const CreateIssueModal = ({ open, onClose, onCreate }) => {
  const [form, setForm] = useState(initialForm);

  const handleChange = field => event => {
    setForm(previousForm => ({
      ...previousForm,
      [field]: event.target.value
    }));
  };

  const handleSelectPatient = patient => {
    setForm(previousForm => ({
      ...previousForm,
      patient
    }));
  };

  const handleCreate = () => {
    if (!isValid) return;

    onCreate({
      ...form,
      patientName: form.patient.name,
      patientMr: form.patient.mr
    });

    setForm(initialForm);
    onClose();
  };

  const handleClose = () => {
    setForm(initialForm);
    onClose();
  };
  

  const isValid = Boolean(
    form.patient &&
      form.category &&
      form.issueNote.trim() &&
      form.priority &&
      form.routeTo
  );

  return (
    <Dialog
      fullWidth
      maxWidth="xs"
      onClose={handleClose}
      open={open}
       PaperProps={{
          sx: {
            borderRadius: '8px'
          }
      }}>
      <DialogTitle sx={dialogHeaderStyles.dialogheader}>
        <Box>
          <Typography sx={dialogHeaderStyles.title}>Issue</Typography>

          <Typography sx={dialogHeaderStyles.subtitle}>Create patient issues and clinical concerns.</Typography>
        </Box>

        <IconButton
          aria-label="Close create issue dialog"
          onClick={handleClose}
          size="small"
          sx={dialogHeaderStyles.dialogheaderclose}>
          <Close sx={{ fontSize: 22 }} />
        </IconButton>
      </DialogTitle>

      <DialogContent sx={{ px: 2, mt: 1 }}>
        <Stack spacing={1.5}>
          <Typography sx={sectionTitleSx}>Patient</Typography>

          <PatientAutocomplete
            onSelectPatient={handleSelectPatient}
            patients={patients}
            value={form.patient}
            width="100%"
            placeholder="Search by patient name or MR#"
          />

          <FormControl fullWidth sx={textFieldSx}>
            <InputLabel id="category-label">Category</InputLabel>
            <Select
              id="category"
              label="Category"
              labelId="category-label"
              IconComponent={KeyboardArrowDownOutlined}
              MenuProps={menuProps}
              onChange={handleChange('category')}
              value={form.category}>
              <MenuItem value="Lab Results">Lab Results</MenuItem>
              <MenuItem value="Medication">Medication</MenuItem>
              <MenuItem value="Clinical Follow-up">Clinical Follow-up</MenuItem>
              <MenuItem value="Imaging Review">Imaging Review</MenuItem>
              <MenuItem value="Medication Side Effects">
                Medication Side Effects
              </MenuItem>
              <MenuItem value="Appointment Scheduling">
                Appointment Scheduling
              </MenuItem>
              <MenuItem value="Insurance Question">Insurance Question</MenuItem>
              <MenuItem value="Test Results">Test Results</MenuItem>
            </Select>
          </FormControl>

          <TextField
            fullWidth
            label="Issue Note"
            minRows={3}
            multiline
            onChange={handleChange('issueNote')}
            sx={multitextFieldSx}
            value={form.issueNote}
          />

          <FormControl fullWidth size="small" sx={textFieldSx}>
            <InputLabel id="priority-label">Priority</InputLabel>

            <Select
              id="priority"
              label="Priority"
              labelId="priority-label"
              MenuProps={menuProps}
              onChange={handleChange('priority')}
              IconComponent={KeyboardArrowDownOutlined}
              value={form.priority}>
              <MenuItem value="Routine">Routine</MenuItem>

              <MenuItem value="High">High</MenuItem>

              <MenuItem value="Urgent">Urgent</MenuItem>
            </Select>
          </FormControl>

          <FormControl fullWidth size="small" sx={textFieldSx}>
            <InputLabel id="route-to-label">Route To</InputLabel>

            <Select
              id="route-to"
              label="Route To"
              labelId="route-to-label"
              IconComponent={KeyboardArrowDownOutlined}
              MenuProps={menuProps}
              onChange={handleChange('routeTo')}
              value={form.routeTo}>
              <MenuItem value="Dr. Henry Low">Dr. Henry Low</MenuItem>

              <MenuItem value="Dr. Alice William">Dr. Alice William</MenuItem>

              <MenuItem value="Dr. Elizabeth David">
                Dr. Elizabeth David
              </MenuItem>
            </Select>
          </FormControl>
        </Stack>
      </DialogContent>

      <CommonDialogActions
        onCancel={handleClose}
        onSubmit={handleClose}
        submitText="CREATE ISSUE"
        disabled={!isValid}
      />
    </Dialog>
  );
};

export default CreateIssueModal;
